import { useId, useLayoutEffect, useRef, useState, type CSSProperties } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export function ExpandableText({ text, className = "", lines = 3 }: { text: string; className?: string; lines?: number }) {
  const id = useId();
  const ref = useRef<HTMLParagraphElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);

  useLayoutEffect(() => { setExpanded(false); }, [text]);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const measure = () => {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      setOverflowing(element.scrollHeight > lineHeight * lines + 1);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [text, lines]);

  return <>
    <p ref={ref} id={id} className={`${className} expandable-text${expanded ? " is-expanded" : ""}`} style={{ "--collapsed-lines": lines } as CSSProperties}>{text}</p>
    {overflowing ? <button className="expandable-text-toggle" type="button" aria-expanded={expanded} aria-controls={id} onClick={() => setExpanded((value) => !value)}>
      {expanded ? "收起" : "展开全文"}{expanded ? <ChevronUp aria-hidden="true" /> : <ChevronDown aria-hidden="true" />}
    </button> : null}
  </>;
}
